import { useMemo } from "react";

// tests for window property added via /js/prebid-ads.js
const useCanRunAds = () => useMemo(() => !!window.canRunBrads, []);

export default useCanRunAds;
